export default {"src":"/_next/static/image/public/images/patient_profile_error.59ce52e1c1c23690fdb050c87c762bc0.svg","height":199,"width":159};